








import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Logo',
  components: {
  }
})

export default class Logo extends Vue {
  t (key: string) {
    return this.$t(`Logo.${key}`)
  }
}
